import { useHomeChat } from "../../context";

export const useResolveDocumentUuid = (message) => {
  const { documents, conversationId } = useHomeChat();

  const att = message?.attachments?.find(
    (a) => a?.fileUuid || a?.document_uuid
  );
  const attachmentUuid = att?.fileUuid ?? att?.document_uuid ?? null;

  if (attachmentUuid) return attachmentUuid;
  if (!message?.id) return null;

  const doc = documents?.find(
    (d) =>
      d.messageId === message.id &&
      (conversationId == null || d.conversationId === conversationId)
  );

  return doc?.documentUuid ?? null;
};
